import { GetInferredFromRaw } from '@thinknimble/tn-models'
import { z } from 'zod'
import { baseModelShape } from '../base-model'
import { organizationShape, userShape } from '../user'

// Custom native enum for search types
export const searchTypeEnum = {
  VECTOR: 'vector',
  QUERY_BUILDER: 'query_builder',
} as const

export type SearchTypeValues = (typeof searchTypeEnum)[keyof typeof searchTypeEnum]

export const searchTypeLabelMap = {
  [searchTypeEnum.VECTOR]: 'Vector Search',
  [searchTypeEnum.QUERY_BUILDER]: 'Query Builder',
}

export const expenseSearchShape = {
  ...baseModelShape,
  query: z.string(),
  searchType: z.enum(searchTypeEnum),
  embedding: z.array(z.number()).nullable().optional(),
  apiFilters: z.record(z.string(), z.any()).nullable().optional(),
  uiFilters: z.record(z.string(), z.any()).nullable().optional(),
  organization: z.string().uuid().nullable().optional(),
  organizationRef: z.object(organizationShape).nullable().optional(),
  user: z.string().uuid(),
  userRef: z.object(userShape).nullable().optional(),
  name: z.string().nullable().optional(),
  asyncJobId: z.string().uuid().nullable().optional(),
}

export const createExpenseSearchShape = {
  query: expenseSearchShape.query,
  searchType: expenseSearchShape.searchType,
  embedding: expenseSearchShape.embedding,
  apiFilters: expenseSearchShape.apiFilters,
  uiFilters: expenseSearchShape.uiFilters,
  organization: expenseSearchShape.organization,
  name: expenseSearchShape.name,
}

export const expenseSearchFilterShape = {
  search: z.string(),
  searchType: z.string(),
  organization: z.array(z.string()),
  user: z.array(z.string()),
}

export type ExpenseSearch = GetInferredFromRaw<typeof expenseSearchShape>
export type CreateExpenseSearch = GetInferredFromRaw<typeof createExpenseSearchShape>
export type ExpenseSearchFilter = GetInferredFromRaw<typeof expenseSearchFilterShape>
